// Alle Inhalte stammen von der Original-Website worldctm.com (Pension Günding Gästehaus)
// Frontend-Only Mock-Daten

export const site = {
  name: "Pension Günding Gästehaus",
  domain: "pensionguending.com",
  tagline: "Günstig wohnen mit Anmeldung",
  claim: "Ihre Pension in Günding bei Dachau – ruhig, zentral, familiär.",
  priceFrom: "ab 15 €",
  priceNote: "1 Bett für eine Nacht",
  region: "München und Umgebung",
};

export const contact = {
  company: "Pension Günding Gästehaus",
  street: "Brucker Straße 24",
  zipCity: "85232 Günding",
  phoneDisplay: "+4915202044440",
  phoneLink: "+4915202044440",
  whatsapp: "4915202044440",
  email: "info@pensionguending.com",
  facebook: "https://www.facebook.com/nawar.jasem.9?fref=ts",
  instagram: "https://www.instagram.com/p/BSwqZc3DNhH/",
  mapsLink:
    "https://www.google.de/maps/place/Brucker+Str.+24,+85232+Bergkirchen/@48.2504501,11.3938379,17z",
  mapsEmbed:
    "https://maps.google.com/maps?q=Brucker%20Stra%C3%9Fe%2024%2C%2085232%20Bergkirchen%2C%20Deutschland&t=&z=16&ie=UTF8&iwloc=B&output=embed",
  languages: ["Deutsch", "Englisch"],
};

export const legalLinks = [
  { to: "/impressum", label: "Impressum" },
  { to: "/datenschutz", label: "Datenschutzerklärung" },
  { to: "/hausordnung", label: "Buchungs- und Hausordnung" },
];

export const navLinks = [
  { id: "start", label: "Startseite" },
  { id: "pension", label: "Die Pension" },
  { id: "ausstattung", label: "Ausstattung" },
  { id: "preise", label: "Preise" },
  { id: "bilder", label: "Bilder" },
  { id: "guending", label: "Über Günding" },
  { id: "kontakt", label: "Kontakt" },
];

export const quickFacts = [
  { icon: "Wifi", title: "Kostenloses WLAN", text: "In allen Bereichen der Unterkunft nutzbar." },
  { icon: "CircleParking", title: "Kostenlose Parkplätze", text: "Private Parkplätze am Haus – ohne Reservierung." },
  { icon: "CookingPot", title: "Gemeinschaftsküche", text: "Eigene Mahlzeiten bequem selbst zubereiten." },
  { icon: "FileCheck2", title: "Mit Anmeldung", text: "Wohnen mit Anmeldung möglich." },
  { icon: "Languages", title: "Wir sprechen Ihre Sprache", text: "Deutsch und Englisch vor Ort." },
];

export const welcome = {
  title: "Willkommen bei der Pension Günding Gästehaus",
  address: [
    "Brucker Straße 24",
    "85232 Günding",
    "2,37 km vom Stadtzentrum Dachau, Deutschland",
  ],
  paragraphs: [
    "Die Pension Günding Gästehaus bietet kostenfreies WLAN in allen Bereichen, Unterkünfte in Günding sowie kostenlose Privatparkplätze am Haus.",
    "In der Gemeinschaftsküche der Unterkunft bereiten Sie bequem Ihre eigenen Mahlzeiten zu.",
    "München liegt 18 km von der Pension Günding Gästehaus entfernt und Augsburg erreichen Sie nach 39 km. Vom nächstgelegenen Flughafen München trennen Sie in der Unterkunft 31 km.",
  ],
  highlight: "Wir sprechen Ihre Sprache!",
};

export const amenities = [
  {
    icon: "Wifi",
    title: "Internet",
    free: true,
    items: ["WLAN in allen Bereichen nutzbar", "Ohne Zusatzkosten"],
  },
  {
    icon: "CircleParking",
    title: "Parkmöglichkeiten",
    free: true,
    items: ["Private Parkplätze am Haus", "Keine Reservierung erforderlich"],
  },
  {
    icon: "CookingPot",
    title: "Küche",
    items: ["Gemeinschaftsküche", "Eigene Mahlzeiten zubereiten"],
  },
  {
    icon: "Flower2",
    title: "Außenbereich",
    items: ["Terrasse", "Sitzplätze im Freien"],
  },
  {
    icon: "WashingMachine",
    title: "Dienstleistungen",
    items: ["Waschsalon", "Wäscheservice"],
  },
  {
    icon: "Info",
    title: "Allgemein",
    items: ["Nur für Erwachsene", "Nichtraucherzimmer", "Raucherbereich vorhanden", "Heizung"],
  },
  {
    icon: "Languages",
    title: "Gesprochene Sprachen",
    items: ["Deutsch", "Englisch"],
  },
  {
    icon: "PawPrint",
    title: "Haustiere",
    items: ["Haustiere sind nicht gestattet"],
  },
];

export const roomFeatures = [
  { icon: "BedDouble", label: "Bett & Bettwäsche" },
  { icon: "Wifi", label: "Free WiFi" },
  { icon: "WashingMachine", label: "Waschmaschine" },
  { icon: "DoorClosed", label: "Kleiderschrank" },
  { icon: "Thermometer", label: "Heizung" },
  { icon: "ShowerHead", label: "Sanitärbereich" },
];

export const gallery = [
  { src: "/images/haus-tag.jpg", alt: "Pension Günding Gästehaus – Ansicht von der Brucker Straße", caption: "Das Haus an der Brucker Straße 24", tag: "Haus" },
  { src: "/images/haus-nacht.jpg", alt: "Pension Günding Gästehaus bei Nacht mit beleuchteten Sitzwürfeln", caption: "Stimmungsvolle Beleuchtung am Abend", tag: "Haus" },
  { src: "/images/zimmer-4bett.jpg", alt: "Mehrbettzimmer mit Betten, Tisch und Schränken", caption: "Mehrbettzimmer mit Essbereich und Schränken", tag: "Zimmer" },
  { src: "/images/zimmer-2bett.jpg", alt: "Zimmer mit zwei Betten, TV und Sitzgruppe", caption: "Zimmer mit TV, Sitzgruppe und Schrank", tag: "Zimmer" },
  { src: "/images/amper.jpg", alt: "Kanufahrer auf der Amper bei Günding", caption: "Die Amper – nur wenige Schritte entfernt", tag: "Umgebung" },
  { src: "/images/muenchen-olympiapark.jpg", alt: "Olympiapark München", caption: "München – 18 km entfernt", tag: "Umgebung" },
];

export const galleryTags = ["Alle", "Haus", "Zimmer", "Umgebung"];

export const guending = {
  title: "Über Günding",
  paragraphs: [
    "Günding ist ein Ortsteil der Gemeinde Bergkirchen im Landkreis Dachau. Er liegt am Rande der Stadt Dachau und hat ungefähr 1.200 Einwohner. Bis zur Gebietsreform in den 1970er Jahren bildete Günding zusammen mit dem Nachbardorf Mitterndorf eine eigenständige Gemeinde. Am 1. Mai 1978 wurde die Gemeinde Günding aufgelöst und in die neue Großgemeinde Bergkirchen eingegliedert.",
    "Der Ort liegt etwa zwei Kilometer westlich von Dachau an der Amper. Nach Breitenau im Westen sind es 1,7 km. Nach München sind es 24 km. Zur Bundesautobahn 8 mit der Anschlussstelle Dachau-Fürstenfeldbruck fährt man Richtung Südwesten 4 km.",
  ],
  facts: [
    { label: "Einwohner", value: "ca. 1.200" },
    { label: "Gemeinde", value: "Bergkirchen" },
    { label: "Landkreis", value: "Dachau" },
    { label: "Fluss", value: "Amper" },
  ],
};

export const distances = [
  { icon: "MapPin", place: "Stadtzentrum Dachau", km: "2,37 km" },
  { icon: "TreePine", place: "Breitenau", km: "1,7 km" },
  { icon: "Milestone", place: "Autobahn A8 (Dachau-Fürstenfeldbruck)", km: "4 km" },
  { icon: "Building2", place: "München", km: "18 km" },
  { icon: "Plane", place: "Flughafen München", km: "31 km" },
  { icon: "Landmark", place: "Augsburg", km: "39 km" },
];

export const faqs = [
  {
    q: "Ist eine Anmeldung (Wohnsitzanmeldung) möglich?",
    a: "Ja. Die Pension Günding Gästehaus bietet günstiges Wohnen mit Anmeldung – sprechen Sie uns einfach telefonisch darauf an.",
  },
  {
    q: "Was kostet eine Übernachtung?",
    a: "1 Bett für eine Nacht ab 15 Euro. Für längere Aufenthalte und individuelle Anfragen erhalten Sie Ihren Preis gerne telefonisch oder per E-Mail.",
  },
  {
    q: "Gibt es Parkplätze?",
    a: "Ja, private Parkplätze stehen kostenfrei direkt an der Unterkunft zur Verfügung. Eine Reservierung ist nicht erforderlich.",
  },
  {
    q: "Kann ich selbst kochen?",
    a: "In der Gemeinschaftsküche der Unterkunft bereiten Sie bequem Ihre eigenen Mahlzeiten zu.",
  },
  {
    q: "Sind Haustiere erlaubt?",
    a: "Haustiere sind leider nicht gestattet.",
  },
  {
    q: "Welche Sprachen werden gesprochen?",
    a: "Wir sprechen Deutsch und Englisch – wir sprechen Ihre Sprache!",
  },
];

export const heroImages = {
  main: "/images/haus-nacht.jpg",
  house: "/images/haus-tag.jpg",
  room: "/images/zimmer-4bett.jpg",
};
